/*jshint esversion:6 */
import React, { Component } from 'react';

/*jshint ignore:start */
export default class ProjectCardContent extends Component {
    render() {
        return (
            <div style = {{display:"flex",flexDirection:"column"}} className="projectCardContent">
                <h3>{this.props.projectName}</h3>
                <p>{this.props.projectDescription}</p>
                <span style = {{alignSelf:this.props.linkAlign}}>
                    <a href = {this.props.projectSrc} rel="noreffer noopener" target="_blank">Source code</a>
                    <a href = {this.props.projectDemoSrc}>{this.props.projectDemoSrc !== "#"?"Demo":"Demo(coming soon)"}</a>
                </span>

            </div>
        )
    }
}
/*jshint ignore:end*/
